import { render, staticRenderFns } from "./TaskDraggable.vue?vue&type=template&id=8722b054"
import script from "./TaskDraggable.vue?vue&type=script&lang=js"
export * from "./TaskDraggable.vue?vue&type=script&lang=js"
import style0 from "./TaskDraggable.vue?vue&type=style&index=0&id=8722b054&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports